import { gql, TypedDocumentNode } from '@apollo/client'
import type {
  UnansweredSafetyQuestionsTabQuery,
  UnansweredSafetyQuestionsTabQueryVariables
} from './__generated__/UnansweredSafetyQuestionsTabQuery'

export const unansweredUnansweredSafetyQuestionsTabQuery: TypedDocumentNode<
  UnansweredSafetyQuestionsTabQuery,
  UnansweredSafetyQuestionsTabQueryVariables
> = gql`
  query UnansweredSafetyQuestionsTabQuery($employeeId: ID!) {
    unansweredSafetyQuestions(employeeId: $employeeId) {
      contractDatum {
        id
        safetyQuestion
      }
      id
      name
    }
  }
`
